import { Map as ImmutableMap } from 'immutable';
import { isDealStage } from './dealGroupingUtils';

// TODO: Remove Immutables from the return type of this function
export const serializeDealRollupData = (row, dealGroupings, dealRollupsCurrencyCode, companyCurrency) => {
  const initialMap = ImmutableMap();
  if (!dealGroupings) {
    return initialMap;
  }

  // Need to cast as Array<any> here to avoid type error with reduce
  return dealGroupings.reduce((dealRollupData, dealGrouping) => {
    const groupingId = isDealStage(dealGrouping) ? dealGrouping.stageId : dealGrouping.value;
    return dealRollupData.set(groupingId, row.dealGroupings && row.dealGroupings[groupingId] || {
      value: 0,
      currencyCode: dealRollupsCurrencyCode || companyCurrency
    });
  }, initialMap);
};